import React from 'react'
import PropTypes from 'prop-types'
import { NavLink, withRouter } from 'react-router-dom'

import { Roles } from 'api/UsersAPI'
import { getMe, logout } from 'utils/auth'

import styles from './index.css'

@withRouter
export default class Nav extends React.Component {
  
  static propTypes = {
  }

  constructor(props) {
    super(props)
    this.logoutClicked = this.logoutClicked.bind(this)
  }

  logoutClicked() {
    logout()
    this.props.history.push('/login')
  }

  render() {
    const me = getMe()
    return (
      <nav className={styles.Nav}>
        <div className={styles.Left}>
          <img className={styles.LogoImage} src='/logo.png'/>
          <div className={styles.VerticalLine}></div>
          <div style={{whiteSpace: 'nowrap'}}>
            <NavLink to='/dashboard' activeClassName='active'>Dashboard</NavLink>
            <NavLink to='/users' activeClassName='active'>Users</NavLink>
            <NavLink to='/timesheets' activeClassName='active'>Time sheets</NavLink>
            <NavLink to='/reports' activeClassName='active'>Reports</NavLink>
          </div>
        </div>
        <div>
          {
            me && me.role == Roles.Admin &&        
            <NavLink to='/settings' activeClassName='active'>Settings</NavLink>
          }
          <button className={styles.LogoutButton} onClick={this.logoutClicked}>
            Logout
          </button>
        </div>
      </nav>
    )
  }

}



// WEBPACK FOOTER //
// ./src/components/Nav/index.jsx